import { ChartContainer, StatsContainer } from "../../components";


export default function Stats() {
  return (
    <>
      <StatsContainer />
      <ChartContainer />
    </>
  );
}
